<template>
	<div class="bg-gray">
		<!-- <BaseNav></BaseNav> -->
		<router-view></router-view>
		<!-- <BaseFooter></BaseFooter> -->
	</div>
</template>

<script>
	// import BaseNav from "@/components/BaseNavigation"
	// import BaseFooter from "@/components/BaseFooter"
	
	export default{
		components:{
			// BaseNav,
			// BaseFooter
		},
		data(){
			return{
				
			}
		}
	}
</script>

<style scoped="scoped">
	.bg-gray {
		background: #F6F7FC;
	}
</style>



// WEBPACK FOOTER //
// src/pages/company/index.vue